import { ref } from "vue";
import firebase from "../../firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import defaultImage from "../assets/images/user/14.jpg";

const getUsers = () => {
  const userIds = ref([]);
  const users = ref([]);
  const error = ref(null);

  const loadUserDetails = async (id) => {
    try {
      const userRef = doc(firebase.db, "users", id);
      const userSnapShot = await getDoc(userRef);

      if (userSnapShot.exists()) {
        const data = userSnapShot.data();
        return {
          id: id,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          devices: data.devices ? data.devices : [],
          profilePic: data.profilePic ? data.profilePic : defaultImage,
        };
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadUsers = async () => {
    try {
      const docRef = doc(
        firebase.db,
        "doctors",
        firebase.firebaseAuth.currentUser.uid
      );
      const docSnapShot = await getDoc(docRef);

      if (docSnapShot.exists()) {
        userIds.value = docSnapShot.data().patients;
        users.value = await Promise.all(
          userIds.value.map((id) => loadUserDetails(id))
        );
      } else {
        console.log("No such document!");
      }
    } catch (err) {
      error.value = err.message;
    }
  };

  return { users, error, loadUsers, loadUserDetails };
};

export default getUsers;
